import {Component, Input, OnInit} from '@angular/core';
import {DashboardDealCardDto} from 'src/app/models/DealsModels';
import {UserModel} from '../../../models/User';
import {canViewDeal} from '../../../helpers/directives/deal-activate.directive';
import {UnlockedStarterDealsService} from '../../../services/unlocked-starter-deals.service';

@Component({
    selector: 'deal-card',
    templateUrl: './deal-card.component.html',
    styleUrl: './deal-card.component.css',
})
export class DealCardComponent implements OnInit{
    @Input() baseDeal!: DashboardDealCardDto;
    @Input() user!: UserModel;

    canView: boolean;

    constructor(private unlockedStarterDeals: UnlockedStarterDealsService){}

    ngOnInit(): void {
        const unlocked = this.unlockedStarterDeals.isUnlocked((this.baseDeal.id))
        this.canView = canViewDeal(this.user, this.baseDeal.minimumTier, this.baseDeal.currentUserGotDeal, unlocked)
    }

}
